import dva from 'dva';
import createHistory from 'history/createHashHistory';
import createLoading from 'dva-loading';

// 1. Initialize
const app = dva({
  history: createHistory()
});
window.g_app = app;

// 2. Plugin
app.use(createLoading())

// 3. Model
app.model(require('./models').default)

// 4. Router
app.router(require('./router').default)

// 5. Start
app.start('#root')
